import { gsap } from 'gsap';
import Hls from 'hls.js';
import jQuery from 'jquery';
import lity from 'lity';
import App from './App';
import Menu from './Menu';

const Video = {
  soundTL: gsap.timeline({ paused: true }), //the values on either end of the path collapse to middle
  mobileVidsLoaded: false,
  ageVideo: document.getElementById('agegate-vid'),
  homeVideo: document.getElementById('menu-vid-home'),
  legacyVideo: document.getElementById('menu-vid-legacy'),
  winesVideo: document.getElementById('menu-vid-wines'),
  visitVideo: document.getElementById('menu-vid-visit'),
  belongVideo: document.getElementById('menu-vid-belong'),
  mobileVidsSrc: {
    agegate: [
      'https://cdn.jwplayer.com/manifests/Ple3mVND.m3u8',
      '/wp-content/uploads/2021/02/age_gate_placeholder.jpg',
    ],
    home: [
      'https://cdn.jwplayer.com/manifests/C3qsv5Im.m3u8',
      '/wp-content/uploads/2021/02/home-placeholder.jpg',
    ],
    legacy: [
      'https://cdn.jwplayer.com/manifests/XMDaFA8W.m3u8',
      '/wp-content/uploads/2021/02/legacy-placeholder.jpg',
    ],
    wines: [
      'https://cdn.jwplayer.com/manifests/18ZjTwES.m3u8',
      '/wp-content/uploads/2021/02/wines-placeholder.jpg',
    ],
    visit: [
      'https://cdn.jwplayer.com/manifests/mqGVzyt1.m3u8',
      '/wp-content/uploads/2021/02/visit-placeholder.jpg',
    ],
    belong: [
      'https://cdn.jwplayer.com/manifests/UHhhq1Gs.m3u8',
      '/wp-content/uploads/2021/02/membership-placeholder.jpg',
    ],
  },
  desktopVidsSrc: {
    agegate: [
      'https://cdn.jwplayer.com/manifests/fjCr97zE.m3u8',
      '/wp-content/uploads/2021/02/age_gate_placeholder.jpg',
    ],
    home: [
      'https://cdn.jwplayer.com/manifests/7BsXyQVI.m3u8',
      '/wp-content/uploads/2021/02/home-placeholder.jpg',
    ],
    legacy: [
      'https://cdn.jwplayer.com/manifests/NOpwqWaM.m3u8',
      '/wp-content/uploads/2021/02/legacy-placeholder.jpg',
    ],
    wines: [
      'https://cdn.jwplayer.com/manifests/UP8PiNtQ.m3u8',
      '/wp-content/uploads/2021/02/wines-placeholder.jpg',
    ],
    visit: [
      'https://cdn.jwplayer.com/manifests/GkYjiR3C.m3u8',
      '/wp-content/uploads/2021/02/visit-placeholder.jpg',
    ],
    belong: [
      'https://cdn.jwplayer.com/manifests/TpcLGLWE.m3u8',
      '/wp-content/uploads/2021/02/membership-placeholder.jpg',
    ],
  },
  initHeroVideo: function () {
    let currentPage = App.getURLPath();

    if (Menu.primaryPages.includes(currentPage) || currentPage === '/') {
      if (currentPage === '/') {
        Video.homeVideo.muted = true;
        //prettier-ignore
        window.addEventListener("load", ()=>{
            Video.homeVideo.play();
        }, false);

        this.soundbar();
      } else if (currentPage == Menu.primaryPages[0]) {
        Video.legacyVideo.play();
      } else if (currentPage == Menu.primaryPages[1]) {
        Video.winesVideo.play();
      } else if (currentPage == Menu.primaryPages[2]) {
        Video.visitVideo.play();
      } else if (currentPage == Menu.primaryPages[3]) {
        Video.belongVideo.play();
      } else {
        //secondary page
      }
    }
  },
  startMenuVideos: function () {
    let panels = ['home', 'legacy', 'wines', 'visit', 'belong'];

    let currentPage = App.getURLPath();

    let playVideos = panels.map((page) => {
      jQuery(`#menu-vid-${page}`)[0].play();
      jQuery(`#menu-vid-${page}`)[0].muted = true;
    });

    //primaryPages:['/legacy','/wines','/visit','/belong']
    setTimeout(() => {
      if (Menu.primaryPages.includes(currentPage) || currentPage === '/') {
        if (currentPage === '/') {
          let panels = ['legacy', 'wines', 'visit', 'belong'];

          let pauseVideos = panels.map((page) => {
            return jQuery(`#menu-vid-${page}`)[0].pause();
          });
        } else if (currentPage == Menu.primaryPages[0]) {
          let panels = ['home', 'wines', 'visit', 'belong'];

          let pauseVideos = panels.map((page) => {
            return jQuery(`#menu-vid-${page}`)[0].pause();
          });
        } else if (currentPage == Menu.primaryPages[1]) {
          let panels = ['home', 'legacy', 'visit', 'belong'];

          let pauseVideos = panels.map((page) => {
            return jQuery(`#menu-vid-${page}`)[0].pause();
          });
        } else if (currentPage == Menu.primaryPages[2]) {
          let panels = ['home', 'legacy', 'wines', 'belong'];

          let pauseVideos = panels.map((page) => {
            return jQuery(`#menu-vid-${page}`)[0].pause();
          });
        } else if (currentPage == Menu.primaryPages[3]) {
          let panels = ['home', 'wines', 'legacy', 'visit'];

          let pauseVideos = panels.map((page) => {
            return jQuery(`#menu-vid-${page}`)[0].pause();
          });
        } else {
          let panels = ['legacy', 'wines', 'visit', 'belong'];

          let pauseVideos = panels.map((page) => {
            return jQuery(`#menu-vid-${page}`)[0].pause();
          });
        }
      } //if
    }, 750);
  },
  panelActiveVideo: function (panelIndex) {
    let panels = ['home', 'legacy', 'wines', 'visit', 'belong'];

    panels.map((page) => {
      return jQuery(`#menu-vid-${page}`)[0].pause();
    });

    switch (panelIndex) {
      case 0:
        Video.homeVideo.play();
        Video.homeVideo.muted = true;
        break;
      case 1:
        Video.legacyVideo.play();
        break;
      case 2:
        Video.winesVideo.play();
        break;
      case 3:
        Video.visitVideo.play();
        break;
      case 4:
        Video.belongVideo.play();
        break;
    }
  },
  pauseMenuVideos: function () {
    if (!Menu.menuOpen) {
      if (Menu.activePanelIndx == 0) {
        let inactivePages = ['legacy', 'wines', 'visit', 'belong'];

        let pauseVideos = inactivePages.map((page) => {
          return jQuery(`#menu-vid-${page}`)[0].pause();
        });
      } else if (Menu.activePanelIndx == 1) {
        //legacy
        let inactivePages = ['home', 'wines', 'visit', 'belong'];

        let pauseVideos = inactivePages.map((page) => {
          return jQuery(`#menu-vid-${page}`)[0].pause();
        });
      } else if (Menu.activePanelIndx == 2) {
        //wines
        let inactivePages = ['legacy', 'home', 'visit', 'belong'];

        let pauseVideos = inactivePages.map((page) => {
          return jQuery(`#menu-vid-${page}`)[0].pause();
        });
      } else if (Menu.activePanelIndx == 3) {
        //visit
        let inactivePages = ['legacy', 'wines', 'home', 'belong'];

        let pauseVideos = inactivePages.map((page) => {
          return jQuery(`#menu-vid-${page}`)[0].pause();
        });
      } else if (Menu.activePanelIndx == 4) {
        //belong
        let inactivePages = ['legacy', 'wines', 'visit', 'home'];

        let pauseVideos = inactivePages.map((page) => {
          return jQuery(`#menu-vid-${page}`)[0].pause();
        });
      }
    }
  },
  videoPanelBehavior: function () {
    jQuery('.slider-panel video').on({
      click: function (e) {
        console.log('video clicked');
        e.preventDefault();
        e.stopPropagation();
      },
    });
  },
  soundbar: function () {
    if (Menu.activePanelIndx == 0) {
      //home page y'all
      Video.soundTL
        .to(
          '#volume-bars #left_1_',
          { duration: 1, attr: { y2: '190' }, ease: 'Power4.InOut' },
          '-=0'
        )
        .to(
          '#volume-bars #middle',
          { duration: 0.9, attr: { y2: '190' }, ease: 'Power4.InOut' },
          '-=.8'
        )
        .to(
          '#volume-bars #right',
          { duration: 0.8, attr: { y2: '190' }, ease: 'Power4.InOut' },
          '-=.7'
        )
        .addLabel('end', '-=0');

      Video.soundTL.yoyo(true).repeat(-1).timeScale(0.9).play();
    }
  },
  soundBarActive: function () {
    Video.homeVideo.play();

    jQuery(document).on('click', '#volume-bars,.volume-helper', function (e) {
      if (Video.homeVideo.muted === false) {
        Video.homeVideo.muted = true;
        Video.soundTL.seek('end').pause();
        jQuery('.volume-helper').html('Unmute');
      } else {
        Video.homeVideo.muted = false;
        Video.soundTL.yoyo(true).repeat(-1).timeScale(0.9).play();
        jQuery('.volume-helper').html('Mute');
      }
    });

    if (!Video.homeVideo.muted) {
      jQuery('.volume-helper').html('Mute');
    } else {
      jQuery('.volume-helper').html('Unmute');
    }
  },
  lityInstance: '',
  lityBind: function () {
    jQuery(document).on('click', 'a[data-vid]', function (e) {
      e.preventDefault();

      let videoTitle = jQuery(this).attr('data-vid');

      switch (videoTitle) {
        case 'brand-film':
          Video.lityInstance = lity('https://vimeo.com/409879416');
          break;
        case 'perspective':
          Video.lityInstance = lity('https://vimeo.com/405672096');
          break;
        case 'slinsen-voltz':
          Video.lityInstance = lity('https://vimeo.com/405672558');
          break;
        case 'cold-springs':
          Video.lityInstance = lity('https://vimeo.com/405672713');
          break;
        case 'estate':
          Video.lityInstance = lity('https://vimeo.com/405673021');
          break;
        default:
          break;
      }
    });
  },
  homeVideoLoader: function () {
    let entries = Object.entries(Video.desktopVidsSrc);

    let step = -1;

    for (const [panel, source] of entries) {
      step++;

      switch (step) {
        case 1:
          Video.attachHLS('menu-vid-home', source[0]);
          break;
      }
    } //for loop
  },
  videoLoaderNotHome: function () {
    let entries;

    if (jQuery(window).width() < 992) {
      return;
    } else {
      entries = Object.entries(Video.desktopVidsSrc);
    } //else

    let step = -1;

    for (const [panel, source] of entries) {
      step++;

      switch (step) {
        case 2:
          Video.attachHLS('menu-vid-legacy', source[0]);
          break;
        case 3:
          Video.attachHLS('menu-vid-wines', source[0]);
          break;
        case 4:
          Video.attachHLS('menu-vid-visit', source[0]);
          break;
        case 5:
          Video.attachHLS('menu-vid-belong', source[0]);
          break;
      }
    } //for loop
  },
  videoLoader: function () {
    let entries;

    if (jQuery(window).width() < 992) {
      return;
    } else {
      entries = Object.entries(Video.desktopVidsSrc);
    } //else

    let step = -1;

    for (const [panel, source] of entries) {
      step++;

      switch (step) {
        case 0:
          if (Video.ageVideo != null) {
            console.log('agegate vid hide');
            Video.attachHLS('agegate-vid', source[0]);
            Video.removeCaptions('agegate-vid');
          }
          break;
        case 1:
          Video.attachHLS('menu-vid-home', source[0]);
          break;
        case 2:
          Video.attachHLS('menu-vid-legacy', source[0]);
          break;
        case 3:
          Video.attachHLS('menu-vid-wines', source[0]);
          break;
        case 4:
          Video.attachHLS('menu-vid-visit', source[0]);
          break;
        case 5:
          Video.attachHLS('menu-vid-belong', source[0]);
          break;
      }
    } //for loop
  },
  removeCaptions: function (videoID) {
    document.getElementById(videoID).textTracks[0].mode = 'hidden';
  },
  attachHLS: function (videoID, manifest) {
    let video = document.getElementById(videoID);

    if (video !== null) {
      if (Hls.isSupported()) {
        let hls = new Hls();
        // bind them together
        hls.attachMedia(video);
        hls.on(Hls.Events.MEDIA_ATTACHED, function () {
          hls.loadSource(manifest);
          hls.on(Hls.Events.MANIFEST_PARSED, function (event, data) {
            // manifest loaded
          });
        });
      } else if (video.canPlayType('application/vnd.apple.mpegurl')) {
        video.src = manifest;
        video.addEventListener('loadedmetadata', function () {
          // video loaded
        });

        Video.removeCaptions(videoID);
      }
    } //if vid exists
  },
  loadedOtherVidsFlag: false,
  homeVideoSelectiveLoad: function () {
    let currentPage = App.getURLPath();

    jQuery('.slider-panel').addClass('loadBkgrd');

    if (window.innerWidth < 992) return;

    if (Menu.primaryPages.includes(currentPage) || currentPage === '/') {
      if (currentPage === '/') {
        Video.homeVideoLoader();
        Video.initHeroVideo();

        //none of the other videos were loaded so load them on menu click
        if (!Video.loadedOtherVidsFlag) {
          Video.loadedOtherVidsFlag = true;
          document.querySelector('#hamburger').addEventListener('click', function () {
            Video.videoLoaderNotHome();
          });
        }
      } else {
        Video.videoLoader();
        Video.initHeroVideo();
      }
    }
  },
  // Load video sources based on screen size
  loadVideoSources: function () {
    const videoElements = document.querySelectorAll('video[data-src]');

    if (!videoElements.length) {
      return; // No video elements found
    }

    // Loop through all video elements
    videoElements.forEach((video) => {
      try {
        const dataSrc = video.getAttribute('data-src');
        const dataSrcMobile = video.getAttribute('data-src-mobile');

        if (!dataSrc) {
          console.warn('Video element missing data-src attribute');
          return;
        }

        // Determine which source to use based on screen size
        const isMobile = window.innerWidth < 768;
        const source = isMobile && dataSrcMobile ? dataSrcMobile : dataSrc;

        // Check if it's an HLS stream (.m3u8)
        if (source.includes('.m3u8')) {
          this.attachHLS(video.id, source);
        } else {
          // For regular video formats
          video.src = source;
        }
      } catch (error) {
        console.error('Error loading video source:', error);
      }
    });
  },
  init: function () {
    this.soundBarActive();
    this.lityBind();
    this.homeVideoSelectiveLoad();
    this.loadVideoSources();
    this.videoPanelBehavior();
  },
};

export default Video;
